export enum Bonds {
  List = 'bonds.list',
  Favorites = 'bonds.favorites',
  Bond = 'bonds.bond',
  sameIssuer = 'bonds.sameIssuer',
  calls = 'bonds.calls',
  couponFormulas = 'bonds.couponFormulas',
  Promo = 'bonds.promotions',
}
